module.exports = __webpack_public_path__ + "static/img/banner-2-hover.dddb69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-2-hover.png
// module id = NQmV
// module chunks = 7